/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Long_WaitInputs */

const en_loading_long_wait = /** @type {(inputs: Loading_Long_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still waiting for the result. The duration depends on this request.`)
};

const id_loading_long_wait = /** @type {(inputs: Loading_Long_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masih menunggu hasilnya. Lama proses bergantung pada permintaan ini.`)
};

/**
* | output |
* | --- |
* | "Still waiting for the result. The duration depends on this request." |
*
* @param {Loading_Long_WaitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_long_wait = /** @type {((inputs?: Loading_Long_WaitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Long_WaitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_long_wait(inputs)
	return en_loading_long_wait(inputs)
});